import InstitutionFuturesExecutionForm from '@/features/institution/futures/execution/components/form';
import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionFuturesExecutionPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="execution" detailsType={INSTITUTION_DETAILS_TYPE.FUTURES}>
      <InstitutionFuturesExecutionForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionFuturesExecutionPage.displayName = 'InstitutionFuturesExecutionPage';

export default InstitutionFuturesExecutionPage;
